import districtsReducer from "./reducers";
export { default as districtsTypes } from "./types";
export { default as districtsOperations } from "./operations";
export default districtsReducer;
